<template>
  <div>
    <list row-key="Record" ref="list" unit="供应商期初应付" page show-index show-query :get-data-func="getDataFunc" show-checkbox
      @check-change="x => delRows = x" :query-before="queryBeforeFunc">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onImprot">导入</el-button>
        <el-button type="primary" plain @click="reviewAll">批量审核</el-button>
        <el-button type="danger" plain @click="backAll">批量弃审</el-button>
        <el-button type="primary" @click="onAdd">添加</el-button>
        <el-button type="primary" @click="onSave" plain>保存</el-button>
        <el-button type="danger" @click="onDelete">删除</el-button>
      </template>
      <template slot="query">
        <el-form-item label="仓库">
          <el-select v-model="params.WarehouseId" @change="changeWarehouse">
            <el-option v-for="(i, k) in warehouseList" :key="k" :label="i.WarehouseName" :value="i.WarehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认入库日期">
          <el-date-picker v-model="params.InDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column min-width="140" align="left" label="入库单号">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 1">{{ row.InNumber }}</span>
            <el-input v-else v-model="row.InNumber" @input="setEdit(row)" placeholder="请输入入库单号" />
          </template>
        </el-table-column>
        <el-table-column min-width="155" label="入库日期" prop="InDate">
          <template slot-scope="{row}">
            <span v-if="row.Status == 1">{{ $commonJs.toDateString(row.InDate) }}</span>
            <el-date-picker v-else v-model="row.InDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="setEdit(row)"
              style="width: 130px;"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column min-width="140" align="left" label="仓库编码" prop="WarehouseNo" />
        <el-table-column min-width="140" align="left" label="仓库名称" prop="WarehouseName" />
        <el-table-column min-width="140" align="left" label="存货编码" prop="ProductNo" />
        <el-table-column label="存货名称" min-width="130">
          <template slot-scope="{row,$index}">
            <span v-if="row.Status == 1">{{ row.ProductName }}</span>
            <product-select v-else v-model="row.ProductName" :source="products" @select="onSelect($event, row, $index)"
              :pageSize="pageParams.pageSize" :pageIndex="pageParams.pageIndex" :listTotal="listTotal" @inputText="inputText"
              @click.native="resetFun" @currentPage="currentPage" pageType />
          </template>
        </el-table-column>
        <el-table-column align="left" label="批号" min-width="300px" >
        <template slot-scope="{ row, $index }">
          <span v-if="!row.ProductName" style="color:#999;">请先选择存货</span>
          <span v-else-if="row.Status == 1">{{ row.BatchNumber }}</span>
          <product-select v-else 
            v-model="row.BatchNumber" 
            :Head='Head'
            :source="batchList"
            :listTotal="batchListTotal" :pageType="true" 
            :pageSize="batchPageParams.pageSize" :pageIndex="batchPageParams.pageIndex"
            @select="onSelBatch($event, row, $index)" 
            @inputText="inputTextBatch($event, row)" 
            @click.native="onOpenBatch($event, row, $index)" 
            @currentPage="currentPageBatch($event, row)" 
            keyword="BatchNumber"/>
        </template>
        </el-table-column>
        <el-table-column min-width="140" align="left" label="规格型号" prop="ProductSpec" />
        <el-table-column min-width="140px" align="left" label="颜色">
          <template slot-scope="{row}">
            <span v-if="row.Status == 1">{{ row.ColorName }}</span>
            <el-select v-else v-model="row.ColorId" @change="setEdit(row)">
              <el-option v-for="(i, k) in row.Colors" :key="k" :value="i.ColorId" :label="i.ColorName" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column min-width="140px" align="left" label="属性">
          <template slot-scope="{row}">
            <span v-if="row.Status == 1">{{ row.PropertyName }}</span>
            <el-select v-else v-model="row.PropertyId" @change="setEdit(row)">
              <el-option v-for="(i, k) in propertys" :key="k" :value="i.PropertyId" :label="i.PropertyName" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="计量单位" min-width="120px">
          <template slot-scope="{ row, $index }">
            <span v-if="row.Status == 1">{{ row.UnitName }}</span>
            <template v-else>
              <el-select v-if="row.Units && row.Units.length > 0" v-model="row.Unit">
                <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"
                  @click.native="compareSaUnit(item, row, $index)"></el-option>
              </el-select>
              <span v-else>{{ row.UnitName }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="center" min-width="100" key="table1_9">
          <template slot-scope="{ row, $index }">
            <span v-if="row.Status == 1">{{ row.Quantity }}</span>
            <el-input v-else type="text" @change="changeQuantity($event, row, $index)" v-model="row.Quantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="换算率" min-width="100">
          <template slot-scope="{ row, $index }">
            <span v-if="row.Status == 1">{{ row.Rate }}</span>
            <template v-else>
              <span v-if="(row.ChangeType === 0) && row.UnitType == 1">{{ row.Rate }}</span>
              <span v-else-if="row.UnitType == 0"></span>
              <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" label="计量单位2" min-width="120px">
          <template slot-scope="{ row, $index }">
            <span v-if="row.Status == 1">{{ row.UnitName2 }}</span>
            <template>
              <el-select v-if="row.Units && row.Units.length > 0" v-model="row.Unit2">
                <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"
                  @click.native="compareUnitId(item, row, $index)"></el-option>
              </el-select>
              <span v-else-if="row.UnitType == 0"></span>
              <span v-else>{{ row.UnitName2 }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="数量2" prop="Quantity2" align="center" min-width="100">
          <template slot-scope="{ row, $index }">
            <span v-if="row.Status == 1">{{ row.Quantity2 }}</span>
            <el-input v-else v-show="row.Unit2" type="text" v-model="row.Quantity2"
              @change="changeQuantity2($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="100" align="left" label="主单价">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 1">{{ row.BasePrice }}</span>
            <el-input v-else v-model="row.BasePrice" @change="onInput(row, 'BasePrice')" placeholder="请输入主单价" />
          </template>
        </el-table-column>
        <el-table-column min-width="100" align="left" label="金额">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 1">{{ row.Amount }}</span>
            <el-input v-else v-model="row.Amount" @change="onInput(row, 'Amount')" placeholder="请输入金额" />
          </template>
        </el-table-column>
        <el-table-column min-width="100" align="left" label="批号">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 1">{{ row.BatchNumber }}</span>
            <el-input v-else v-model="row.BatchNumber" @change="setEdit(row)" placeholder="请输入批号" />
          </template>
        </el-table-column>
        <el-table-column min-width="140" align="left" label="供应商编码" prop="TradeUnitNo" />
        <el-table-column min-width="180px" align="left" label="供应商名称">
          <template slot-scope="{row}">
            <span v-if="row.Status == 1">{{ row.TradeUnitName }}</span>
            <template v-else>
              <el-select v-model="row.TradeUnitId" filterable @change="changeTu($event, row)">
                <el-option v-for="(i, k) in tradeUnitList" :key="k" :value="i.TradeUnitId" :label="i.FullName" />
              </el-select>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="right" label="制单人">
          <template slot-scope="{ row }">
            <span>{{ row.MakeEmpName }}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>

import listMixin from "@/mixins/list";
import optionMixins from "@/mixins/option";
import list from "@/components/common/list";
import productSelect from "@/components/business/sales/select";
import importDialog from "./importDialog";


export default {
  mixins: [listMixin, optionMixins],
  components: { list, productSelect,importDialog },
  data() {
    return {
      api: require("@/api/stock/inventoryPeriodBeginning").default,
      pdApi: require("@/api/ba/product").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      productApi: require("@/api/ba/product").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      propertyApi: require("@/api/ba/property").default,
      tradeUnitList: [],
      warehouseList: [],
      params: {
        WarehouseId: null,
        WarehouseNo: "",
        WarehouseName: "",
        InDate: null,
      },
      user: {
        EmpId: null,
        EmpName: "",
      },
      delRows: [],
      listTotal: 0,
      initTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      products: [],
      initProducts: [],
      propertys: [],
      Head:[
        { Value: "BatchNumber", Name: "批号", Width: "180" },
        { Value: "WarehouseName", Name: "仓库", Width: "100" },
        { Value: "ColorName", Name: "颜色", Width: "80" },
        { Value: "PropertyName", Name: "属性", Width: "80" },
        { Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        { Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: "BaseUnitName", Name: "主单位", Width: "80" }, 
        { Value: "BaseQuantity", Name: "现存量", Width: "80" }
      ],
      batchListTotal:0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      batchList:[]
    };
  },
  mounted() {
    const user = this.$store.state.user;
    if (user) {
      this.user.EmpId = user.empId;
      this.user.EmpName = user.name;
    }
    this.$refs.list.reload();
    this.callOptionApi();
    this.tradeUnitApi.list({ TradeUnitTypes: [1, 2], Status: 1 }).then((res) => {
      if (res.Code == 0) this.tradeUnitList = res.Data;
    });
    this.productApi.list({ ...this.pageParams, Property: "销售", Status: 1, }).then((res) => {
      this.products = res.Data;
      this.initProducts = res.Data;
      this.listTotal = res.Count;
      this.initTotal = res.Count;
    });
    this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then((res) => {
      if (res.Code === 0) {
        this.warehouseList = res.Data;
      }
    });
    this.propertyApi.list({ Status: 1 }).then(res => {
      if (res.Code == 0) {
        this.propertys = res.Data;
      }
    })
  },
  methods: {
    onImprot() {
      this.$refs.importDialog.open();
    },
    setEdit(row) {
      if (row.T !== 0) row.T = 1;
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(2));
    },
    changeTu(id, row) {
      this.setEdit(row);
      var tu = this.tradeUnitList.find(x => x.TradeUnitId == id);
      row.TradeUnitNo = tu.TradeUnitNo;
    },
    onInput(row, type) {
      this.setEdit(row);
      row[type] = parseFloat(Number(row[type]).toFixed(2));

      if (type == "BasePrice") {
        if (row[type] && row.Quantity) {
          row.Amount = parseFloat((Number(row.Quantity) * Number(row.BasePrice)).toFixed(2));
        } else {
          row.Amount = 0;
        }
      }
      if (type == "Amount") {
        if (row[type] && row.Quantity) {
          row.BasePrice = parseFloat((Number(row.Amount) / Number(row.Quantity)).toFixed(2));
        } else {
          row.BasePrice = 0;
        }
      }
    },
    changeWarehouse(val) {
      let item = this.warehouseList.find(x => x.WarehouseId == val);
      console.log("仓库", item);
      this.params.WarehouseNo = item.WarehouseNo;
      this.params.WarehouseName = item.WarehouseName;
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      this.setEdit(row);

      row.Rate = data;
      row.Rate = Number(row.Rate).toFixed(2);
      if (row.IsMain) {
        row.Quantity2 = this.getQuantity(row.Quantity / Number(data));
      } else {
        row.Quantity = this.getQuantity(row.Quantity2 / Number(data));
      }
    },
    changeQuantity(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") return;
      this.setEdit(row);

      if (row.Units.length > 0) {
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate));
        } else {
          row.Quantity2 = this.getQuantity(data * Number(row.Rate));
        }
      } else {
        row.Quantity2 = row.Quantity;
      }

      if (row.BasePrice) {
        row.Amount = parseFloat((Number(row.Quantity) * Number(row.BasePrice)).toFixed(2));
      } else {
        row.Amount = 0;
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") return;
      this.setEdit(row);

      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(2);
        } else {
          console.log("数量1=数量2/换算率");
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(2);
        } else {
          console.log("数量1=数量2*换算率");
          row.Quantity = this.getQuantity(data * row.Rate);
        }
      }
    },

    /*计量单位相关函数*/
    compareUnitId(data, row, index) {
      this.setEdit(row);

      let lastIsMain = row.IsMain;
      if (data.IsMain) {
        row.IsMain = false;
      } else {
        row.IsMain = true;
      }
      let findIndex = 0;
      if (row.Unit == row.Unit2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (row.IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeLeftUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeLeftUnitId(row, findIndex);
        }
      } else {
        if (row.IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeLeftUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeLeftUnitId(row, findIndex, data.Rate);
          if (!lastIsMain) {
            row.Quantity = row.Quantity2;
          }
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate));
        }
      }
      this.changeQuantity2(row.Quantity2, row, index, 1);
    },
    changeLeftUnitId(row, findIndex, Rate = 0) {
      row.Unit = row.Units[findIndex].UnitId;
      row.UnitName = row.Units[findIndex].UnitName;
      if (Rate > 0) {
        row.Rate = Rate;
      }
    },
    compareSaUnit(data, row, index) {
      this.setEdit(row)

      let lastIsMain = row.IsMain;
      row.IsMain = data.IsMain;
      let findIndex = 0;
      if (row.Unit == row.Unit2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeRightUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeRightUnitId(row, findIndex);
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, row.Units);
          this.changeRightUnitId(row, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, row.Units);
          this.changeRightUnitId(row, findIndex, data.Rate);
          if (lastIsMain) {
            row.Quantity2 = row.Quantity;
          }
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate));
        }
      }
      this.changeQuantity(row.Quantity, row, index, 1);
    },
    changeRightUnitId(row, findIndex, Rate = 0) {
      row.Unit2 = row.Units[findIndex].UnitId;
      row.UnitName2 = row.Units[findIndex].UnitName;
      if (Rate > 0) {
        row.Rate = Rate;
      }
    },
    /****************/

    /*存货选择框相关函数*/
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.products = this.initProducts;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val;
      var params = { ...this.pageParams, Property: "销售", Status: 1, ProductName: text1 };
      this.productApi.list(params).then((res) => {
        if (res.Code == 0) {
          this.products = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text) {
      var params = { Property: "销售", pageIndex: 1, pageSize: 7, ProductName: text, Status: 1 };
      this.productApi.list(params).then((res) => {
        if (res.Code == 0) {
          this.products = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    // 选择存货名称
    onSelect(e, row, index) {
      console.log("e", JSON.parse(JSON.stringify(e)));

      this.setEdit(row);

      row.ColorId = null;
      row.PropertyId = null;
      row.BatchNumber = null;

      row.UnitName = "";
      row.UnitName2 = "";
      row.ColorName = "";
      row.WarehouseId = this.params.WarehouseId;
      row.WarehouseNo = this.params.WarehouseNo;
      row.WarehouseName = this.params.WarehouseName;
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.UseBatchNumber = e.BatchNumber; //是否启用批号
      row.Colors = e.Colors;
      row.Units = e.Units;
      row.Unit = e.SkUnitId;
      row.ChangeType = 0;
      row.UnitType = 0;
      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;

      

      if (e.Units.length === 0) {
        row.Unit = e.SkUnitId;
        row.UnitName = e.SkUnitName;
      } else {
        row.UnitType = 1;
        e.Units.forEach((item) => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
        });
        if (row.Unit) {
          let index = this.getUnitIndex(3, e.Units, row.Unit);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = assistData.Rate.toFixed(5);
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = data.Rate.toFixed(5);
          }
          row.Unit2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.Unit = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.Unit2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = noMainData[0].Rate.toFixed(5);
          row.IsMain = true;
        }
      }
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    //获取计量单位的值
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    /******************/

    /*查询添加删除保存*/
    queryBeforeFunc() {
      if (!this.params.WarehouseId) {
        this.$message.warning("请先选择仓库");
        return false;
      } else {
        return true;
      }
    },
    getDataFunc(params) {
      params = { ...params, ...this.params };
      params = this.$commonJs.obj.removeNullKey(params);
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          res.Data = res.Data.map(x => {
            if (x.Units.length === 0 || x.Units == null) {
              x.UnitType = 0;
            } else {
              x.UnitType = 1;
              let unit = x.Units.find(v => x.Unit === v.UnitId);
              if (unit) x.IsMain = unit.IsMain;
              x.Units.forEach(v => {
                if (v.ChangeType == 1) x.ChangeType = v.ChangeType
              })
            }
            return { ...x, T: null }
          })
          resolve(res);
        })
      })
    },
    onAdd() {
      this.$refs.list.data.push({
        Id: 0,
        InDate: this.params.InDate, //入库日期
        InNumber: "", //入库单号
        WarehouseId: this.params.WarehouseId, //仓库
        WarehouseNo: this.params.WarehouseNo,
        WarehouseName: this.params.WarehouseName,
        ProductId: null, //存货
        ProductName: "", //存货名称
        ProductNo: "", //存货编码
        ProductSpec: "", //规格型号
        PropertyId: null, //属性
        PropertyName: "",
        UseProcess: false, //启用属性
        ColorId: null, //颜色
        Colors: [],
        UseColor: false,
        BatchNumber: "", //批号
        UseBatchNumber: false,
        Unit: null, //单位
        UnitName: "",
        Unit2: null, //单位2
        UnitName2: "",
        Units: [],
        ChangeType: 0, //单位换算类型
        UnitType: 0, //0：单计量，1：多计量
        IsMain: false,
        Quantity: null, //数量
        Quantity2: null, //数量2
        BaseQuantity: null, //主数量
        SubQuantity: null, //辅数量
        BaseUnit: null, //主单位
        SubUnit: null, //辅单位
        Rate: null, //换算率
        TradeUnitId: null, //供应商
        TradeUnitName: null,
        TradeUnitNo: null,
        MakeEmpId: this.user.EmpId, //制单人
        MakeEmpName: this.user.EmpName,
        Amount: null, //金额
        Price: null, //单价
        Price2: null, //单价2
        BasePrice: null, //主单价
        SubPrice: null, //辅单价
        T: 0,
      });
    },
    onDelete() {
      if (this.delRows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log("删除", this.delRows);
        var ids = this.delRows.filter(x => x.Id > 0).map(x => x.Id)

        var data = this.$refs.list.data;
        this.delRows.forEach((x) => {
          var index = data.indexOf(x);
          this.$refs.list.data.splice(index, 1);
        });

        if (ids.length > 0) {
          this.api.delete({ ids: ids }).then((res) => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              // this.reload();
            } else {
              this.$message.error("删除失败");
              // this.reload();
            }
          })
        }
      }).catch(() => { });
    },
    onSave() {
      var listData = this.$refs.list.data;

      var data = listData.filter(x => x.T != null);
      // data = data.filter(x =>
      //   x.TradeUnitId ||
      //   x.OrigPrepayAmount ||
      //   x.Amount ||
      //   x.OrigBalanceAmount);

      console.log("save", JSON.parse(JSON.stringify(data)));

      if (data.some(x => !x.InDate)) {
        this.$message.warning("入库日期");
        return;
      }
      if (data.some(x => !x.InNumber)) {
        this.$message.warning("入库单号不能为空");
        return;
      }
      if (data.some(x => !x.ProductId)) {
        this.$message.warning("存货不能为空");
        return;
      }
      if (data.some(x => x.UseColor == true && !x.ColorId)) {
        this.$message.warning("颜色不能为空");
        return;
      }
      if (data.some(x => x.UseProcess == true && !x.PropertyId)) {
        this.$message.warning("属性不能为空");
        return;
      }
      if (data.some(x => !x.Quantity)) {
        this.$message.warning("数量不能为空");
        return;
      }
      if (data.some(x => x.Unit2 != null && !x.Quantity2)) {
        this.$message.warning("数量2不能为空");
        return;
      }
      if (data.some(x => !x.BasePrice)) {
        this.$message.warning("主单价不能为空");
        return;
      }
      if (data.some(x => !x.Amount)) {
        this.$message.warning("金额不能为空");
        return;
      }
      if (data.some(x => x.UseBatchNumber && !x.BatchNumber)) {
        this.$message.warning("批号不能为空");
        return;
      }

      // return;
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.save(data).then(res => {
        if (res.Code == 0) {
          loading.close();
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    reviewAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要审核的数据");
        return;
      }
      this.$confirm("确认审核所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.Id);
        this.api.review({ ids }).then(res => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        })
      }).catch(() => { });
    },
    backAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要弃审的数据");
        return;
      }
      this.$confirm("确认弃审所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.Id);
        this.api.back({ ids }).then(res => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        })
      }).catch(() => { });
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      this.batchPageParams.pageIndex = 1;
      let o = {
        IsInOut:1,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 选择批号 */
    onSelBatch(e, row, index){
      if (row.T !== 0) {
        row.T = 1
      }
      if(e.BatchNumber !== row.BatchNumber){
        row.BatchNumber = e.BatchNumber
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text;
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut:1,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        BatchNumber:row.BatchNumber,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val;
      let o = {
        IsInOut:1,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        ProductName:row.ProductName,
        pageIndex: val,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    }
  }
};
</script>
